// extracted by mini-css-extract-plugin
export default {"card":"H8-z"};